package com.macrofocus.eflux.ui

import com.macrofocus.eflux.network.DerivedBranchColumn
import com.macrofocus.eflux.network.physical.Branch
import js.objects.unsafeJso
import mui.material.Grid
import mui.material.Paper
import mui.material.Typography
import mui.material.TypographyAlign
import mui.material.styles.TypographyVariant
import mui.system.sx
import org.molap.aggregates.cube.DistributiveStatistics
import org.molap.dataframe.DataFrame
import org.molap.dataframe.rowmajor.RowMajorDataFrame
import org.molap.series.Series
import react.FC
import react.Props
import web.cssom.*

external interface BranchSparklineColumnProps : Props {
    var branch: Branch?
    var getWidth: Double
    var dataFrame: DataFrame<Branch, RowMajorDataFrame.Column<Branch, Any?>, Any?>
    var dateTime: Series<Any?, *>
    var dateTimeStatistics: DistributiveStatistics
    var paletteType: PaletteType
    var props: SparklineDataFrameTableProps
    var column: DerivedBranchColumn
}

val BranchSparklineColumn = FC<BranchSparklineColumnProps> { props ->
    val branch = props.branch
    val getWidth: Double = props.getWidth
    val dataFrame: DataFrame<Branch, RowMajorDataFrame.Column<Branch, Any?>, Any?> = props.dataFrame
    val dateTime: Series<Any?, *> = props.dateTime
    val dateTimeStatistics: DistributiveStatistics = props.dateTimeStatistics
    val paletteType: PaletteType = props.paletteType
    val column: DerivedBranchColumn = props.column
    val props: SparklineDataFrameTableProps = props.props

    Grid {
        sx {
            this.display = Display.flex
            this.justifyContent = JustifyContent.spaceBetween
        }
//        style = unsafeJso {
//            display = Display.flex
//            justifyContent = JustifyContent.spaceBetween
//        }
//        this.asDynamic().justifyContent = "space-between"

        Typography {
            sx {
                minWidth = 0.px
                overflow = Overflow.hidden
            }

            variant = TypographyVariant.caption
            align = TypographyAlign.left
            +column.longName
        }

        if(branch != null) {
            val formattedValue = column.getFormattedValue(branch)
            if(formattedValue != null) {
                Typography {
                    variant = TypographyVariant.caption
                    align = TypographyAlign.right
                    +formattedValue
                }
            }
        }
    }

//    Typography {
//        variant = "caption"
//        +(column as DerivedBranchColumn).longName
//    }

    val series = dataFrame.getColumn(column) as Series<Any?, *>?
    val statistics = if (series != null) DistributiveStatistics(series) else null

    if(statistics?.mean != null) {
        Paper {
            sx = unsafeJso {
                marginTop = 2.px
                marginBottom = 2.px
                marginLeft = 4.px
                marginRight = 4.px

                backgroundColor = if (paletteType == PaletteType.dark) Color("#062333") else Color("white")
                if (statistics?.mean != null) {
                    flexShrink = number(2.0)
                    flexGrow = number(1.0)
                    flexBasis = 0.px
                }

                minHeight = 0.px
            }
            elevation = 4

            Sparkline {
                this.series = series
                this.maximum = statistics.maximum
                this.minimum = statistics.minimum
                this.getWidth = getWidth
                this.dateTime = dateTime
                this.dateTimeStatistics = dateTimeStatistics
                this.statistics = statistics
                this.paletteType = paletteType
                this.displayDateTime = props.dateTime
            }
        }
    } else {
        // Do not display categorical attribute
    }
}